
const BASE_API_URL = 'https://api.traffy.xyz/';

let constants = {
  GA_TRACKING_ID : 'UA-72505920-1',
  STOP_URL : BASE_API_URL + 'stop/',
  INCOMING_BUS_SUFFIX : 'incoming_bus/',
  CONSOLE_LINE: 15,
}

export default constants;



/** WEBPACK FOOTER **
 ** ./src/app/constants.js
 **/